import { render, staticRenderFns } from "./Atendimentos.vue?vue&type=template&id=17a28efd&"
import script from "./Atendimentos.vue?vue&type=script&lang=js&"
export * from "./Atendimentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports